import React, { useEffect, useState, useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Grid,
  Switch,
} from "@material-ui/core";
import {
  ExpandMore as ExpandMoreIcon,
  Search as SearchIcon,
} from "@material-ui/icons/";

import HeaderModule from "../../../components/header/HeaderModule";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import SelectErp from "../../../components/basics/SelectErp";
import Btn from "../../../components/buttons/Btn";
import Loading from "../../../components/basics/Loading";
import MaskService from "../../../utils/mask/maskService";
import Chip from "../../../components/basics/Chip";
import { findTransportadora } from "../../../repositories/qerpapi/erp/prouser/v1/TransportadorasRepository";
import { PainelContainer, HeaderAccordion } from "./styles/Transportadora";
import useTransportadoraController from "./controllers/TransportadoraController";
import { TransportadoraContext } from "./contexts/TransportadoraContext";
import { validarCNPJ, validarCPF } from "../../../utils/validations";
import { GlobalVariables } from "../../../GlobalVariables";

let temporizer = null;
const CadastroTransportadora = ({ location }) => {
  const {
    handleCep,
    handleCpfCnpj,

    handleSubmit,
    queryParams,
    handleBackSubmit,

    handleClearContext,
  } = useTransportadoraController();

  const {
    setTipoCpfCnpj,
    name,
    setName,
    fantasy,
    setFantasy,

    cep,
    setCep,
    address,
    setAddress,
    number,
    setNumber,

    complement,
    setComplement,
    district,
    setDistrict,
    uf,
    setUf,
    county,
    setCounty,

    listUf,

    listCounty,

    telephone1,
    setTelephone1,

    telephone2,
    setTelephone2,
    email,
    setEmail,
    ieRg,
    setIeRg,
    rntrc,
    setRntrc,
    contato,
    setContato,
    errors,

    cpfCnpj,
    setCpfCnpj,

    setTransportadoraId,

    loading,
    setLoading,

    loadingInputs,
    active,
    setActive,

    celular,
    setCelular,
    whatsappActive,
    setWhatsappActive,
    validCpfCnpj,
    setValidCpfCnpj,
  } = useContext(TransportadoraContext);
  const [dataTransporterEdit, setDataTransporterEdit] = useState({});

  useEffect(() => {
    if (!location?.state?.item?.id) {
      handleClearContext();
      return;
    }
    setTransportadoraId(location.state.item.id || null);

    (async () => {
      try {
        setLoading(true);

        const dataCustomer = await findTransportadora(
          queryParams.empresa_cnpj,
          location.state.item.id,
          ""
        );

        if (!dataCustomer.success || !dataCustomer.data) return;

        const data = dataCustomer.data;
        setDataTransporterEdit(data);

        //Dados Gerais
        if (data.cnpj_cpf) {
          const cpfOrCnpj =
            data.cnpj_cpf.replace(/[^0-9]+/g, "").length === 11
              ? "cpf"
              : "cnpj";

          if (cpfOrCnpj === "cpf") {
            setValidCpfCnpj(validarCPF(data?.cnpj_cpf || ""));
          } else {
            setValidCpfCnpj(validarCNPJ(data?.cnpj_cpf || ""));
          }

          setTipoCpfCnpj(
            data.cnpj_cpf.replace(/[^0-9]+/g, "").length === 11
              ? { description: "CPF", value: "cpf" }
              : { description: "CNPJ", value: "cnpj" }
          );
          // setActive(data.ativo === "S");
          setCpfCnpj(MaskService.toMask(cpfOrCnpj, data.cnpj_cpf || ""));
        }

        setName(data.razao || "");
        setFantasy(data.apelido || "");
        setCep(MaskService.toMask("cep", data.cep || ""));
        setAddress(data.endereco.split(",")[0] || "");
        setNumber((data.endereco.split(",")[1] || "").trim() || "");
        setComplement(data.complemento_end || "");
        setDistrict(data.bairro || "");

        setTelephone1(
          MaskService.toMask(
            "cel-phone",
            `${data.ddd1 || ""}${data.telefone1 || ""}`
          )
        );
        setTelephone2(
          MaskService.toMask(
            "cel-phone",
            `${data.ddd2 || ""}${data.telefone2 || ""}`
          )
        );

        setEmail(data.email || "");
        setIeRg(data.inscricao_estadual || "");
        setRntrc(data.rntrc || "");
        setEmail(data.email1 || "");
        setContato(data.contato1 || "");
        setCelular(data.celular || "");
        setWhatsappActive(data.whatsapp_ativo === 1);
        setActive(data.status ? true : false);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [
    location,
    handleClearContext,
    queryParams.empresa_cnpj,
    setActive,
    setAddress,
    setCep,
    setComplement,
    setContato,
    setCpfCnpj,
    setDistrict,
    setEmail,
    setFantasy,
    setIeRg,
    setLoading,
    setName,
    setNumber,
    setRntrc,
    setTelephone1,
    setTelephone2,
    setTipoCpfCnpj,
    setTransportadoraId,
    setCelular,
    setWhatsappActive,
    setValidCpfCnpj,
  ]);

  useEffect(() => {
    if (!dataTransporterEdit.id_estado) {
      return;
    }

    setUf(
      listUf.find((opt) => opt.id === dataTransporterEdit.id_estado) || null
    );
  }, [dataTransporterEdit, listUf, setUf]);

  useEffect(() => {
    if (!dataTransporterEdit.municipio_codigo) {
      return;
    }

    setCounty(
      listCounty.find(
        (opt) => opt.codigo === dataTransporterEdit.municipio_codigo
      ) || null
    );
  }, [dataTransporterEdit, listCounty, setCounty]);

  const handleInputUser = (e) => {
    let newInput = e.target.value.replaceAll(/[^0-9]/g, "");
    let mask;
    let updatedInput = newInput;

    if (newInput.length === 14) {
      mask = "cnpj";
      updatedInput = MaskService.toMask(mask, newInput);
    } else if (newInput.length === 11) {
      mask = "cpf";
      updatedInput = MaskService.toMask(mask, newInput);
    }
    setCpfCnpj(updatedInput);

    clearTimeout(temporizer);
    temporizer = setTimeout(() => {
      handleCpfCnpj(updatedInput);
    }, 1800);
  };

  return (
    <>
      <HeaderModule
        title="CADASTRO DE TRANSPORTADORAS"
        videoId={GlobalVariables.screenVideosIds.cadastroTransportadora}
      />

      <PainelContainer maxWidth="xl">
        <Loading open={loading} />

        <Accordion expanded={true}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    bgcolor={
                      errors.accordions && errors.accordions.includes("general")
                        ? "red"
                        : "primary"
                    }
                    textcolor="white"
                    label="DADOS GERAIS"
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item lg={3} md={2} sm={5} xs={12}>
                <TextFieldErp
                  error={errors.cpfCnpj ? true : false}
                  helperText={errors.cpfCnpj || ""}
                  label="CPF, CNPJ ou CÓD*"
                  value={cpfCnpj}
                  setValue={setCpfCnpj}
                  onBlur={(e) => handleInputUser(e)}
                  InputProps={{
                    endAdornment: <SearchIcon onClick={() => {}} />,
                  }}
                  disabled={validCpfCnpj}
                />
              </Grid>

              <Grid item lg={5} md={4} sm={7} xs={12}>
                <TextFieldErp
                  helperText={errors.name || ""}
                  error={errors.name ? true : false}
                  label="Razão/Nome*"
                  maxLength={50}
                  value={name}
                  setValue={setName}
                />
              </Grid>

              <Grid item lg={4} md={4} sm={7} xs={12}>
                <TextFieldErp
                  helperText={errors.name || ""}
                  error={errors.name ? true : false}
                  label="Fantasia*"
                  maxLength={20}
                  value={fantasy}
                  setValue={setFantasy}
                />
              </Grid>

              <Grid item lg={2} md={2} sm={5} xs={12}>
                <TextFieldErp
                  helperText={errors.cep || ""}
                  error={errors.cep ? true : false}
                  value={cep}
                  onChange={handleCep}
                  label="CEP*"
                  InputProps={{
                    endAdornment: <SearchIcon onClick={() => {}} />,
                  }}
                />
              </Grid>

              <Grid item lg={5} md={5} sm={12} xs={8}>
                <TextFieldErp
                  helperText={errors.address || ""}
                  error={errors.address ? true : false}
                  label="Endereço*"
                  maxLength={50}
                  value={address}
                  setValue={setAddress}
                />
              </Grid>

              <Grid item lg={1} md={1} sm={2} xs={4}>
                <TextFieldErp
                  label="Número"
                  maxLength={50}
                  value={number}
                  setValue={setNumber}
                />
              </Grid>

              <Grid item lg={4} md={6} sm={10} xs={12}>
                <TextFieldErp
                  label="Complemento"
                  maxLength={50}
                  value={complement}
                  setValue={setComplement}
                />
              </Grid>

              <Grid item lg={4} md={6} sm={4} xs={12}>
                <TextFieldErp
                  label="Bairro"
                  maxLength={60}
                  value={(district || "").slice(0, 60)}
                  setValue={setDistrict}
                />
              </Grid>

              <Grid item lg={2} md={3} sm={4} xs={12}>
                <SelectErp
                  error={errors.uf ? true : false}
                  helperText={errors.uf || ""}
                  loading={loadingInputs.optionsEstado || false}
                  label="Estado*"
                  value={uf}
                  setValue={setUf}
                  optionsList={listUf}
                  descriptionField="estado"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={4} xs={12}>
                <SelectErp
                  error={errors.county ? true : false}
                  helperText={errors.county || ""}
                  loading={loadingInputs.optionsMunicipio || false}
                  label="Municipio*"
                  value={county}
                  setValue={setCounty}
                  optionsList={
                    uf
                      ? listCounty.filter(
                          (opt) => opt.estado_codigo === uf.codibge
                        )
                      : []
                  }
                  descriptionField="municipio"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.telephone1 ? true : false}
                  helperText={errors.telephone1 || ""}
                  label="Telefone 1"
                  value={telephone1}
                  setValue={setTelephone1}
                  mask="cel-phone"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.telephone2 ? true : false}
                  helperText={errors.telephone2 || ""}
                  label="Telefone 2"
                  value={telephone2}
                  setValue={setTelephone2}
                  mask="cel-phone"
                />
              </Grid>

              <Grid item lg={3} md={3} sm={3} xs={12}>
                <TextFieldErp
                  label="Contato"
                  maxLength={30}
                  value={contato}
                  setValue={setContato}
                />
              </Grid>

              <Grid item lg={2} md={2} sm={6} xs={12}>
                <TextFieldErp
                  label="Celular"
                  value={celular}
                  setValue={setCelular}
                  mask="cel-phone"
                />
              </Grid>

              <Grid item xl={1} lg={1} md={2} sm={2} xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={whatsappActive}
                      onChange={() => setWhatsappActive((current) => !current)}
                      color="primary"
                    />
                  }
                  label="Whatsapp"
                  labelPlacement="end"
                />
              </Grid>

              <Grid item lg={4} md={3} sm={4} xs={12}>
                <TextFieldErp
                  error={errors.email ? true : false}
                  helperText={errors.email || ""}
                  label="E-mail"
                  maxLength={100}
                  value={email}
                  setValue={setEmail}
                />
              </Grid>

              <Grid item lg={3} md={3} sm={3} xs={12}>
                <TextFieldErp
                  label="RNTRC"
                  maxLength={8}
                  value={rntrc}
                  setValue={setRntrc}
                />
              </Grid>

              <Grid item xl={5} lg={4} md={4} sm={5} xs={12}>
                <TextFieldErp
                  label="Inscrição Estadual"
                  maxLength={18}
                  value={ieRg}
                  setValue={setIeRg}
                />
              </Grid>

              <Grid item xl={1} lg={1} md={2} sm={2} xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={active}
                      onChange={() => setActive((current) => !current)}
                      color="primary"
                    />
                  }
                  label="Ativo"
                  labelPlacement="end"
                />
              </Grid>

              <Grid
                item
                container
                justifyContent="flex-end"
                style={{ marginTop: 20, marginBottom: 20 }}
                spacing={1}
              >
                <Grid item>
                  <Btn
                    label="Voltar"
                    bgcolor="tertiary"
                    onClick={handleBackSubmit}
                  />
                </Grid>
                <Grid item>
                  <Btn label="Salvar" onClick={() => handleSubmit(false)} />
                </Grid>
                <Grid item>
                  <Btn
                    label="Salvar e Novo"
                    onClick={() => handleSubmit(true)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </PainelContainer>
    </>
  );
};

export default CadastroTransportadora;
